import { useNavigate } from "react-router-dom";
import { FileText, GitBranch, Library } from "lucide-react";
import { contractIQActions } from "../../config/navigation";
import { useModuleAccess } from "../../hooks/useModuleAccess";

const iconConfig: Record<
  string,
  {
    bg: string;
    text: string;
    icon: React.ReactNode;
  }
> = {
  "contract-list": {
    bg: "bg-menu-list",
    text: "text-primary",
    icon: <FileText className="h-6 w-6" />
  },
  "upload-review": {
    bg: "bg-menu-upload",
    text: "text-violet-600",
    icon: <GitBranch className="h-6 w-6" />
  },
  "template-library": {
    bg: "bg-menu-library",
    text: "text-emerald-600",
    icon: <Library className="h-6 w-6" />
  }
};

export const ContractIQMenu = () => {
  const navigate = useNavigate();
  const { canContracts } = useModuleAccess();

  if (!canContracts) {
    return (
      <p className="text-sm text-muted-foreground">
        You do not have access to ContractIQ. Contact your administrator if you need access.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        {contractIQActions.map((card) => {
          const cfg = iconConfig[card.id] ?? iconConfig["contract-list"];
          return (
            <button
              key={card.id}
              type="button"
              onClick={() => navigate(card.route)}
              className="flex w-full items-center gap-4 rounded-xl border border-[var(--border)] bg-card p-4 text-left shadow-sm transition-colors hover:border-primary hover:bg-accent"
            >
              <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${cfg.bg} ${cfg.text}`}>
                {cfg.icon}
              </div>
              <div>
                <p className="font-semibold text-foreground">{card.title}</p>
                <p className="text-sm text-muted-foreground">{card.description}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
